import React from "react";
import { t } from "i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { ConfirmationModalProps } from "@models/components/modals.model";

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  cancelButtonText = t("cancel"),
  isLoading = false,
  isOpen,
  modalBodyText,
  modalHeaderText,
  showSubmitButton = true,
  submitAction,
  submitButtonDisabled = false,
  submitButtonText = t("submit"),
  updateModalState,
}) => {
  const handleSubmit = async () => {
    if (submitAction) {
      await submitAction();
    }
  };
  return (
    <Modal
      data-testid="confirmation-modal"
      isOpen={isOpen}
      toggle={updateModalState}
    >
      <ModalHeader data-testid="modal-header" toggle={updateModalState}>
        {modalHeaderText}
      </ModalHeader>
      <ModalBody>{modalBodyText}</ModalBody>
      <ModalFooter className="border-0">
        <div className="btn-grp text-end">
          <button
            className="btn fg-btn fg-btn-grey mb-0"
            data-testid="cancel-confirmation-modal"
            onClick={updateModalState}
            disabled={isLoading}
          >
            {cancelButtonText}
          </button>
          {showSubmitButton && (
            <button
              className="btn fg-btn fg-btn-lightblue ms-3 mb-0"
              data-testid="submit-confirmation-modal"
              disabled={isLoading || submitButtonDisabled}
              onClick={handleSubmit}
            >
              {submitButtonText}
            </button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
